import { FormGroup } from "../../styles/FormGroup";

type DateInputProps = {
    name: string;
    label?: string;
    onChange: (name: string, value: string) => void;
    value?: string;
    error?: string;
    required?: boolean;
    [key: string]: any;
};

const DateInput = ({ name, label, onChange, required = false, value = "", error = "", ...props }: DateInputProps) => {
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        onChange(name, value);
    };
    const date = value.split("T");

    return (
        <FormGroup>
            {label ? (
                <label htmlFor={name}>
                    {label}
                    {required ? " *" : ""}
                </label>
            ) : (
                ""
            )}
            <input
                {...props}
                name={name}
                type="date"
                className="form-control"
                onChange={handleChange}
                value={date[0]}
            />
            {error ? <span className="field-error small">{error}</span> : ""}
        </FormGroup>
    );
};

export default DateInput;
